<template>
  <div>
    <div>
      <h1 class="mb-2">Групи</h1>
      <GroupCreator
        v-on:refresh="getSchedule()"
        v-on:success="showModalCreate('Група успішно створена!', 'green')"
        v-on:req-error="showModalCreate('Щось пішло не так!', 'red')"
        class="mb-2"
      />
      <div>
        <div class="col-4">
          <b-form-group
            label="Пошук"
            label-for="filter-input"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Введіть текст пошуку"
              ></b-form-input>

              <b-input-group-append>
                <b-button class="ms-3" :disabled="!filter" @click="filter = ''"
                  >Очистити</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <b-tabs content-class="mt-3" class="mt-2">
          <b-tab title="Василенко, 9">
            <b-table
              hover
              :fields="fields"
              :filter="filter"
              :items="computeScheduleFirstClub(1)"
              bordered
              @row-clicked="
                (item) => $set(item, '_showDetails', !item._showDetails)
              "
            >
              <template #row-details="row">
                <b-row class="mb-2" v-if="row.item.days.length > 0">
                  <b-card>
                    <b>Дні</b>
                    <hr />
                    <div v-for="day in row.item.days" :key="day.id">
                      <p style="font-weight: bold">{{ day.name | toLocale }}</p>
                    </div>
                  </b-card>
                </b-row>
              </template>
              <template #cell(Действия)="row">
                <b-button
                  size="sm"
                  variant="outline-success"
                  class="me-3"
                  v-on:click="detailedView(row.item.group)"
                >
                  Детальніше
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Острозького, 55">
            <b-table
              hover
              :fields="fields"
              :items="computeScheduleFirstClub(2)"
              bordered
              @row-clicked="
                (item) => $set(item, '_showDetails', !item._showDetails)
              "
            >
              <template #row-details="row">
                <b-row class="mb-2" v-if="row.item.days.length > 0">
                  <b-card>
                    <b>Дні</b>
                    <hr />
                    <div v-for="day in row.item.days" :key="day.id">
                      <p style="font-weight: bold">{{ day.name | toLocale }}</p>
                    </div>
                  </b-card>
                </b-row>
              </template>
              <template #cell(Действия)="row">
                <b-button
                  size="sm"
                  variant="outline-success"
                  class="me-3"
                  v-on:click="detailedView(row.item.group)"
                >
                  Детальніше
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <group-details v-bind:group="chosenGroup"></group-details>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
import GroupCreator from "@/components/modals/groupCreator";
import GroupDetails from "@/components/modals/GroupDetails";
import axios from "axios";
import { mapActions, mapState } from "vuex";
import Alert from "@/components/Toasts/Alert";
export default {
  name: "Groups",
  components: { GroupCreator, Alert, GroupDetails },
  data: function () {
    return {
      groups: null,
      fields: ["Назва", "Час", "Тренер", "Вартість", "Дії"],
      activErr: "",
      class: "",
      filter: null,
      AlertText: "",
      chosenGroup: null,
    };
  },
  computed: {
    ...mapState(["schedule", "trainers", "user"]),
  },
  async created() {
    await this.getSchedule();
    this.groups = this.schedule;
  },
  methods: {
    ...mapActions(["setSchedule", "logOutUser"]),
    detailedView(group) {
      this.chosenGroup = group;
      this.$root.$emit("bv::show::modal", "modal-group-details");
    },
    computeScheduleFirstClub(clubId) {
      let options = [];
      let groups = this.schedule.filter((training) => {
        return training.club_id === clubId;
      });
      if (!groups) {
        return [];
      }
      groups.forEach((training) => {
        options.push({
          id: training.id,
          Назва: training.name,
          Час: training.daytime,
          days: training.group_days,
          Тренер: training.trainer
            ? training.trainer.name + " " + training.trainer.surname
            : "Нема тренера",
          Вартість: training.visit_cost,
          _showDetails: false,
          description: training.description ? training.description : null,
          group: training,
        });
      });
      return options;
    },
    async getSchedule() {
      await axios
        .get(`${process.env.VUE_APP_API}/staticschedule/get`, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          this.setSchedule(response.data.Schedule);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
    async deleteGroup(groupId) {
      await axios
        .delete(`${process.env.VUE_APP_API}/staticschedule/delete/${groupId}`, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          if (error.response.status !== 401) {
            console.log(error.response.status);
          } else {
            this.logOutUser();
          }
        });
    },
  },
  filters: {
    toLocale: function (day) {
      if (day === "Monday") {
        return "Понеділок";
      } else if (day === "Tuesday") {
        return "Вівторок";
      } else if (day === "Wednesday") {
        return "Середа";
      } else if (day === "Thursday") {
        return "Четвер";
      } else if (day === "Friday") {
        return "П'ятниця";
      } else if (day === "Saturday") {
        return "Субота";
      } else if (day === "Sunday") {
        return "Неділя";
      } else {
        return day;
      }
    },
  },
};
</script>

<style scoped></style>
